/** 星闪 DK63 V2：单灯位 / 双灯位（与公版 DK63 keyboardType=63 共用类型，须用 PID 区分） */
export const XINGSHAN_DK63V2_VENDOR_ID = 0x1ca6; // 7334
export const XINGSHAN_DK63V2_PRODUCT_IDS = [0x1c4d, 0x1c49] as const; // 7245 单灯 / 7241 双灯

/** 公版 DK63（非 V2）底行右簇：RAlt、←、↓、→、Fn */
export const DK63_BOTTOM_ROW_TRAILING = [230, 80, 81, 79, 61697] as const;

/** DK63 V2 底行右簇：RAlt、Fn、←、↓、→（与实物/SDK 一致） */
export const DK63V2_BOTTOM_ROW_TRAILING = [230, 61697, 80, 81, 79] as const;

export function isXingshanDk63V2Device(
  productId?: number | string,
  vendorId?: number | string
): boolean {
  const vid = Number(vendorId);
  const pid = Number(productId);
  if (!Number.isFinite(vid) || !Number.isFinite(pid)) return false;
  return (
    vid === XINGSHAN_DK63V2_VENDOR_ID &&
    (XINGSHAN_DK63V2_PRODUCT_IDS as readonly number[]).includes(pid)
  );
}

/**
 * 在公版 63 矩阵上套用 DK63 V2 底行（仅 WASD 槽位定位等场景使用，勿改共享 KEYBOARD_LAYOUTS["63"]）。
 * 底行 col9–13：RAlt、Fn、←、↓、→
 */
export function applyDk63V2BottomRowToLayout63(
  matrix: number[][] | undefined
): number[][] | undefined {
  if (!matrix?.length) return matrix;
  return matrix.map((row, rowIndex) => {
    if (rowIndex !== 5 || !row?.length || row.length < 14) return row;
    const next = row.slice();
    next[9] = DK63V2_BOTTOM_ROW_TRAILING[0];
    next[10] = DK63V2_BOTTOM_ROW_TRAILING[1];
    next[11] = DK63V2_BOTTOM_ROW_TRAILING[2];
    next[12] = DK63V2_BOTTOM_ROW_TRAILING[3];
    next[13] = DK63V2_BOTTOM_ROW_TRAILING[4];
    return next;
  });
}
